import cls from "./Table.module.scss";
import { useDispatch } from "react-redux";
import { resetCount, setPause } from "../../shared/redux/game/slice";
import { Scrollbar } from "../../shared/ui/Scrollbar/Scrollbar";
import router, { ROUTES } from "../../app/router";
import { FormattedMessage } from "react-intl";

const Table = () => {
  const dispatch = useDispatch();

  return (
    <div className={cls.container}>
      <div className={cls.contentContainer}>
        <h2>
          <FormattedMessage id="leaderboard__title" />
        </h2>
        <Scrollbar children={<div className={cls.listContainer} />} />
        <button
          onClick={() => {
            dispatch(resetCount());
            dispatch(setPause(false));
            router.navigate(ROUTES.GAME);
          }}
        >
          <FormattedMessage id="leaderboard__btn-text" />
        </button>
      </div>
    </div>
  );
};

export default Table;
